import Vue from 'vue';
import Vuex from 'vuex';

// import user from './modules/user';
import activityTimer from './modules/activityTimer';
import notifications from './modules/notifications';
import auth from './modules/auth';
import global from './modules/global';
import navigation from './modules/navigation';
import clients from './modules/clients';
import orders from './modules/orders';
import builds from './modules/builds';
import branding from './modules/branding';
import billing from './modules/billing';
import user from './modules/user';
import timezones from './modules/timezones';
import firm from './modules/firm';
import markups from './modules/markups';
import materials from './modules/materials';
import parts from './modules/parts';
import payments from './modules/payments';
import notificationSettings from './modules/notificationSettings';
import tutorial from './modules/tutorial';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    activityTimer,
    notifications,
    auth,
    global,
    navigation,
    clients,
    orders,
    builds,
    branding,
    billing,
    user,
    timezones,
    firm,
    markups,
    materials,
    parts,
    payments,
    notificationSettings,
    tutorial
  }
});
